export default "__VITE_ASSET__DAjLglZo__"